module.exports = __webpack_public_path__ + "static/media/WellLogo.c2770883.svg";